import Button from "components/basic/button";
import { useTranslation } from "react-i18next";
import { DashboardProfileData } from "../..";
import { headerOffset } from "components/basic/header";
import { useTheme } from "@mui/material";
import { DEFAULT_PROFILE_TAB_HEIGHT } from "components/basic/tabs";
import { useNavigate } from "react-router-dom";
import BrandIdentityFields from "./components/BrandIdentityFields";

interface BrandIdentityProfileDashboardProps {
  dashboardProfileData: DashboardProfileData;
  onChange: (name: string, value: string | boolean) => void;
}

const BrandIdentityProfileDashboard: React.FC<
  BrandIdentityProfileDashboardProps
> = ({ dashboardProfileData, onChange }) => {
  const theme = useTheme();
  const { t } = useTranslation("profile");
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        overflow: "auto",
        scrollbarWidth: "thin",
        width: "100%",
        height: `calc(100vh - ${headerOffset(DEFAULT_PROFILE_TAB_HEIGHT + 1)})`,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          padding: theme.spacing(1.8),
          // Stretches to the parent's fixed viewport height, so the padding
          // has to sit inside it or it forces a scrollbar.
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            maxWidth: "560px",
            overflowY: "auto",
            scrollbarWidth: "thin",
          }}
        >
          <BrandIdentityFields
            dashboardProfileData={dashboardProfileData}
            onChange={onChange}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: theme.spacing(2),
            gap: theme.spacing(2),
          }}
        >
          <Button
            style={{
              color: theme.palette.common.white,
              fontSize: "1.2em",
              fontWeight: "bold",
              padding: `0 ${theme.spacing(10)}`,
            }}
            variant="contained"
            color="primary"
            onClick={() => navigate("profile/documents")}
            size="large"
          >
            {t("back")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BrandIdentityProfileDashboard;
